import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { brandColors } from 'brandColors';
import { matchPage, Page } from 'constants/pages';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { usePages } from './pages';

interface Props {
  page: Page;
  open: boolean;
  level?: number;
}

export const MenuItem: React.FC<Props> = (props) => {
  const { page, open, level } = props;
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const pages = usePages();

  const activePage: Page | undefined = matchPage(location.pathname, pages) || undefined;

  const active = activePage?.path === page.path || false;
  let iconColor = 'none';
  let textColor = theme.palette.info.contrastText;
  if (active) {
    iconColor = theme.palette.primary.main;
    textColor = theme.palette.primary.main;
  } else if (page.details?.color) {
    iconColor = page.details.color;
    textColor = page.details.color;
  }

  return (
    <>
      <ListItem key={page.title} sx={{ display: 'block' }} classes={{ root: 'p-0' }}>
        <ListItemButton
          sx={{
            minHeight: 64,
            justifyContent: 'center',
            px: 2,
            pl: level !== undefined && open ? (level + 1) * 2 : 2,
            transition: theme.transitions.create(['width', 'padding-left'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }}
          onClick={() => navigate(page.path)}
        >
          <div>
            <div
              className="rounded-full w-8 h-8 mr-3 flex items-center justify-center"
              style={{
                background: iconColor,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  justifyContent: 'center',
                  color: active ? brandColors.colors.gray[1000] : theme.palette.info.contrastText,
                  display: 'flex',
                }}
              >
                {page.PageIcon}
              </ListItemIcon>
            </div>
          </div>
          <ListItemText
            primary={page.title}
            classes={{ primary: 'font-medium' }}
            sx={{
              opacity: open ? 1 : 0,
              color: textColor,
              fontSize: 16,
            }}
          />
        </ListItemButton>
      </ListItem>
      {page.children ? (
        <div>
          {page.children.map((child) => (
            <MenuItem
              key={child.title}
              page={child}
              open={open}
              level={level === undefined ? 1 : level + 1}
            />
          ))}
        </div>
      ) : null}
    </>
  );
};
